import React, { useState, useEffect } from 'react';
import { Modal, Button, List, Icon } from 'semantic-ui-react';
import { StyledModal, StyledConfirm } from './SharedStyles';
import * as api from '../services/api';

const TemplateListModal = ({ open, onClose, onClone }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cloning, setCloning] = useState(null);
  const [confirmDeleteUuid, setConfirmDeleteUuid] = useState(null);

  useEffect(() => {
    if (open) loadTemplates();
  }, [open]);

  const loadTemplates = async () => {
    setLoading(true);
    try {
      const data = await api.getTemplateTasks();
      setTemplates(data);
    } catch (err) {
      console.error('Error loading templates:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleClone = async (templateUuid) => {
    setCloning(templateUuid);
    try {
      const newTask = await api.cloneTemplate(templateUuid);
      onClose();
      onClone(newTask);
    } catch (err) {
      console.error('Error cloning template:', err);
    } finally {
      setCloning(null);
    }
  };

  const handleDelete = async () => {
    try {
      await api.deleteTask(confirmDeleteUuid);
      setConfirmDeleteUuid(null);
      loadTemplates();
    } catch (err) {
      console.error('Error deleting template:', err);
    }
  };

  return (
    <>
      <StyledModal open={open} onClose={onClose} size="small">
        <Modal.Header>Templates</Modal.Header>
        <Modal.Content>
          <List divided relaxed>
            {templates.map(t => (
              <List.Item key={t.uuid}>
                <List.Content style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <strong>{t.label}</strong>
                    {t.content && <span style={{ marginLeft: '1em', color: '#666' }}>{t.content}</span>}
                  </div>
                  <div style={{ whiteSpace: 'nowrap' }}>
                    <Button
                      size="mini"
                      primary
                      icon
                      labelPosition="left"
                      loading={cloning === t.uuid}
                      disabled={cloning !== null}
                      onClick={() => handleClone(t.uuid)}
                    >
                      <Icon name="copy" />
                      Clone
                    </Button>
                    <Icon
                      name="trash"
                      link
                      color="red"
                      style={{ marginLeft: '0.75em' }}
                      onClick={() => setConfirmDeleteUuid(t.uuid)}
                    />
                  </div>
                </List.Content>
              </List.Item>
            ))}
            {!loading && templates.length === 0 && (
              <List.Item>
                <List.Content>
                  <em>No templates yet. Create a task list and check "Save as template".</em>
                </List.Content>
              </List.Item>
            )}
          </List>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Close</Button>
        </Modal.Actions>
      </StyledModal>
      <StyledConfirm
        open={confirmDeleteUuid !== null}
        header="Delete Template"
        content="This will permanently delete this template and all its tasks. This cannot be undone."
        confirmButton="Delete"
        onCancel={() => setConfirmDeleteUuid(null)}
        onConfirm={handleDelete}
      />
    </>
  );
};

export default TemplateListModal;
